import React from "react";
import { ASSETS } from "../../data/content";

// Official Peil Consultancy Ltd logo. The source art has a white background,
// so `mix-blend-multiply` drops the white against the light theme surfaces.
export const Logo = ({ className = "", showTagline = false, onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="peil-logo"
      className={`group flex items-center gap-3 select-none ${className}`}
      aria-label="Peil Consultancy Ltd — home"
    >
      <img
        src={ASSETS.logo}
        alt="Peil Consultancy Ltd"
        className="h-10 md:h-11 w-auto object-contain mix-blend-multiply transition-transform duration-300 group-hover:scale-[1.03]"
      />
      {showTagline && (
        <span className="hidden lg:block ml-1 pl-4 border-l border-brand-line font-mono text-[9px] uppercase tracking-[0.2em] text-brand-muted">
          Human Capital · Africa
        </span>
      )}
    </button>
  );
};

export default Logo;
